import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DragHandleIcon from '@mui/icons-material/DragHandle';
import {
  Divider,
  IconButton,
  ListItem as ListItemUI,
  ListItemButton,
  ListItemText,
  Tooltip,
  styled,
} from '@mui/material';
import PropTypes from 'prop-types';
import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {includeExtent} from '../actions/map.js';
import {select as selectMosaic} from '../actions/mosaics.js';
import {modes, setMode} from '../actions/ui.js';
import {DRAG_TYPE} from '../common.js';
import {Thumbnail} from './list.jsx';

const ListItem = styled(ListItemUI)(({comparing, theme}) => ({
  border: comparing ? '2px solid grey' : 'none',
  backgroundColor: (theme.vars ?? theme).palette.background.paper,
  ...theme.applyStyles('light', {backgroundColor: 'white'}),
}));

const MosaicListItem = props => {
  const onDragStart = event => {
    event.dataTransfer.setData(DRAG_TYPE, props.mosaic.name);
  };

  const onClick = () => {
    props.dispatch(includeExtent(props.mosaic.bbox));
    props.dispatch(selectMosaic(props.mosaic.name));
  };

  const onSelectClick = () => {
    if (!props.active) {
      onClick();
    }
    props.dispatch(setMode(modes.SELECTION));
  };

  const secondaryAction = (
    <>
      <Tooltip
        title={
          props.isCompareMode ? 'Drag to compare' : 'View Quads and Scenes'
        }
      >
        <IconButton
          data-qe={
            props.isCompareMode ? 'drag-mosaic-button' : 'result-quads-button'
          }
          onClick={props.isCompareMode ? null : onSelectClick}
          size="large"
        >
          {props.isCompareMode ? <DragHandleIcon /> : <ChevronRightIcon />}
        </IconButton>
      </Tooltip>
    </>
  );

  return (
    <Fragment>
      <ListItem
        draggable={props.isCompareMode}
        component="div"
        slotProps={{
          root: {
            'data-qe': 'mosaic-result',
          },
        }}
        comparing={props.comparing ? 1 : 0}
        onClick={onClick}
        onDragStart={onDragStart}
        disablePadding
        secondaryAction={secondaryAction}
      >
        <ListItemButton selected={props.active}>
          <Thumbnail src={props.mosaic._links.thumb} width={100} height={100} />
          <ListItemText
            primary={props.mosaic.title}
            secondary={props.mosaic.name}
            primaryTypographyProps={{
              noWrap: true,
              component: 'div',
            }}
            secondaryTypographyProps={{
              noWrap: true,
              component: 'div',
            }}
            sx={{flexGrow: 0, width: 200}}
          />
        </ListItemButton>
      </ListItem>
      <Divider />
    </Fragment>
  );
};

const mapStateToProps = state => ({
  isCompareMode: state.ui.mode === modes.COMPARE,
});

MosaicListItem.propTypes = {
  active: PropTypes.bool.isRequired,
  comparing: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  mosaic: PropTypes.object.isRequired,
  isCompareMode: PropTypes.bool,
};

export default connect(mapStateToProps)(MosaicListItem);
